import type { RequestServiceOptions } from './types';

export const defaultRequestServiceOptions: RequestServiceOptions = {};

